module.exports = __webpack_public_path__ + "static/logo-label@1x-d6b20b2cee53effa367560dc91757dbd.png";